    import React from 'react';

    // onStart: App.js에서 전달받은 handleStart 함수입니다.
    // 클릭 시 테스트 상태(step)를 'test'로 변경하여 질문 화면을 띄웁니다.
    function StartScreen({ onStart }) {
    return (
        <div className="screen-container start-screen">
        <div className="title-box">
            <h1>✈️<br/>나의 여행 스타일 테스트</h1>
            <p>비행기 표 끊기 전에 필수! 나만 몰랐던 운명의 여행지 찾기 !</p>
        </div>

        {/* 테스트 시작 버튼 */}
        {/* pulse-anim 클래스는 App.css에서 정의한 두근거리는 애니메이션 효과를 적용합니다. */}
        <button className="primary-btn pulse-anim" onClick={onStart}>
            테스트 시작하기
        </button>
        </div>
    );
    }

    export default StartScreen;